// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mKWplX {
  position: relative;
  width: 100%;
}

.JOmzBA {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: 24px;
  color: var(--text-neutral-dark);
  margin: 0 0 var(--spacing-0) 0;
  padding: 0;
  display: block;
}

.gsJJ1E {
  width: 100%;
  padding: var(--spacing-1-5);
  padding-right: var(--spacing-5);
  border: 1px solid var(--surface-neutral-silver);
  background-color: var(--surface-neutral-pale);
  border-radius: var(--radius-s);
  outline: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-1);
  transition: background-color var(--transition-fast);
  position: relative;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: 24px;
  color: var(--text-neutral-dark);
  min-height: 40px;
}

.gsJJ1E:hover:not(.gQRSZT) {
  background-color: var(--surface-neutral-subtle);
}

.gsJJ1E:focus {
  outline: 1px solid var(--surface-primary-medium);
  outline-offset: 1px;
}

.gsJJ1E.gQRSZT {
  cursor: not-allowed;
  opacity: var(--opacity-0-5);
  background-color: var(--surface-neutral-pale);
}

.gsJJ1E.rgJf1U {
  border-color: var(--status-error);
}

.gsJJ1E.iRdYj5 {
  min-height: var(--spacing-4);
  font-size: var(--font-size-sm);
}

.gsJJ1E.MCO9fP {
  min-height: var(--spacing-5);
  font-size: var(--font-size-md);
}

.gsJJ1E.tar2mf {
  min-height: var(--spacing-6);
  font-size: var(--font-size-lg);
}

.GGX7Xq {
  flex: 1;
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  text-align: left;
  min-width: 0;
}

.uNBOrV {
  flex: 1;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.uNBOrV:empty::before {
  content: attr(data-placeholder);
  color: var(--text-neutral-stronger);
}

.eY4iBQ {
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: 24px;
  color: var(--text-neutral-dark);
  min-width: 0;
  padding: 0;
}

.eY4iBQ::placeholder {
  color: var(--text-neutral-strong);
}

.JzNcgd {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-0-5);
  padding: 0 var(--spacing-1);
  background-color: var(--surface-primary-subtle);
  border: 1px solid var(--surface-primary-medium);
  border-radius: var(--radius-pill);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-100);
  color: var(--text-primary-medium);
  height: 24px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.PkggcX {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.INUkmm {
  white-space: nowrap;
}

.pj2d3R {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin-left: var(--spacing-0-5);
  background: none;
  border: none;
  cursor: pointer;
  outline: none;
  flex-shrink: 0;
  transition: opacity var(--transition-fast);
}

.pj2d3R:hover {
  opacity: var(--opacity-0-8);
}

.pj2d3R:focus {
  outline: 1px solid var(--surface-primary-medium);
  outline-offset: 2px;
  border-radius: var(--radius-xs);
}

.AflIZ4 {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  filter: brightness(0) saturate(100%) invert(44%) sepia(92%) saturate(2686%) hue-rotate(6deg) brightness(76%)
    contrast(104%);
  transition: filter var(--transition-fast);
}

.pj2d3R:hover .AflIZ4 {
  filter: brightness(0) saturate(100%) invert(12%) sepia(4%) saturate(230%) hue-rotate(330deg) brightness(76%)
    contrast(95%);
}

.K55Zi3 {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  outline: none;
  flex-shrink: 0;
  position: absolute;
  right: var(--spacing-1-5);
}

.K55Zi3:focus {
  outline: 1px solid var(--surface-primary-medium);
  outline-offset: 2px;
  border-radius: var(--radius-xs);
}

.K55Zi3:disabled {
  cursor: not-allowed;
  opacity: var(--opacity-0-5);
}

.NwcPXK {
  color: var(--surface-primary-medium);
  width: var(--spacing-2);
  height: var(--spacing-2);
  transition: transform var(--transition-normal);
  pointer-events: none;
  flex-shrink: 0;
}

.KOA7gx {
  transform: rotate(180deg);
}

.DtzwLA {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: var(--surface-neutral-white);
  border: 1px solid var(--surface-neutral-silver);
  border-radius: var(--radius-s);
  box-shadow: var(--shadow-sm);
  z-index: 1000;
  margin-top: 2px;
  max-height: 250px;
  overflow-y: auto;
  animation: IlqWIT var(--transition-normal);
}

.UNynuF {
  padding: 10px 12px;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: 20px;
  color: var(--text-neutral-dark);
  background-color: var(--surface-neutral-white);
  cursor: pointer;
  transition: background-color var(--transition-fast);
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  border: none;
  width: 100%;
  text-align: left;
}

.UNynuF:nth-child(odd) {
  background-color: var(--surface-neutral-pale);
}

.UNynuF.YORTC_ {
  color: var(--text-neutral-dark);
}

.UNynuF.gQRSZT {
  cursor: not-allowed;
  opacity: var(--opacity-0-5);
  color: var(--text-neutral-medium);
}

.XiGi4k {
  display: flex;
  align-items: center;
  pointer-events: none;
}

.XiGi4k > * {
  pointer-events: auto;
}

.Rq4zwI {
  flex: 1;
  text-align: left;
}

@keyframes IlqWIT {
  from {
    opacity: 0;
    transform: translateY(calc(var(--spacing-1) * -1));
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.yZwL_B {
  padding: var(--spacing-2);
  text-align: center;
  color: var(--text-neutral-medium);
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-style: italic;
  background-color: var(--surface-neutral-pale);
}

@media (max-width: 768px) {
  .JOmzBA {
    margin-bottom: var(--spacing-1);
  }

  .gsJJ1E {
    padding: var(--spacing-1) var(--spacing-1-5);
    padding-right: var(--spacing-4);
  }

  .UNynuF {
    padding: var(--spacing-1) var(--spacing-1-5);
  }

  .JzNcgd {
    font-size: var(--font-size-xs);
    padding: var(--spacing-0-5);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/MultiSelectDropdown/MultiSelectDropdown.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,iBAAiB;EACjB,+BAA+B;EAC/B,8BAA8B;EAC9B,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,+BAA+B;EAC/B,+CAA+C;EAC/C,6CAA6C;EAC7C,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,mDAAmD;EACnD,kBAAkB;EAClB,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,iBAAiB;EACjB,+BAA+B;EAC/B,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,+CAA+C;EAC/C,+CAA+C;EAC/C,iCAAiC;EACjC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,iCAAiC;EACjC,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd;kBACgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE;iBACe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,wBAAwB;EACxB,8CAA8C;EAC9C,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,8CAA8C;EAC9C,+CAA+C;EAC/C,8BAA8B;EAC9B,4BAA4B;EAC5B,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,0CAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,iBAAiB;EACjB,+BAA+B;EAC/B,8CAA8C;EAC9C,eAAe;EACf,mDAAmD;EACnD,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,kDAAkD;EACpD;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iCAAiC;EACjC,oCAAoC;EACpC,8BAA8B;EAC9B,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,4CAA4C;IAC5C,+BAA+B;EACjC;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,8BAA8B;IAC9B,2BAA2B;EAC7B;AACF","sourcesContent":[".container {\n  position: relative;\n  width: 100%;\n}\n\n.label {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: 24px;\n  color: var(--text-neutral-dark);\n  margin: 0 0 var(--spacing-0) 0;\n  padding: 0;\n  display: block;\n}\n\n.dropdownTrigger {\n  width: 100%;\n  padding: var(--spacing-1-5);\n  padding-right: var(--spacing-5);\n  border: 1px solid var(--surface-neutral-silver);\n  background-color: var(--surface-neutral-pale);\n  border-radius: var(--radius-s);\n  outline: none;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--spacing-1);\n  transition: background-color var(--transition-fast);\n  position: relative;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: 24px;\n  color: var(--text-neutral-dark);\n  min-height: 40px;\n}\n\n.dropdownTrigger:hover:not(.disabled) {\n  background-color: var(--surface-neutral-subtle);\n}\n\n.dropdownTrigger:focus {\n  outline: 1px solid var(--surface-primary-medium);\n  outline-offset: 1px;\n}\n\n.dropdownTrigger.disabled {\n  cursor: not-allowed;\n  opacity: var(--opacity-0-5);\n  background-color: var(--surface-neutral-pale);\n}\n\n.dropdownTrigger.error {\n  border-color: var(--status-error);\n}\n\n.dropdownTrigger.small {\n  min-height: var(--spacing-4);\n  font-size: var(--font-size-sm);\n}\n\n.dropdownTrigger.medium {\n  min-height: var(--spacing-5);\n  font-size: var(--font-size-md);\n}\n\n.dropdownTrigger.large {\n  min-height: var(--spacing-6);\n  font-size: var(--font-size-lg);\n}\n\n.dropdownContent {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  text-align: left;\n  min-width: 0;\n}\n\n.dropdownValue {\n  flex: 1;\n  text-align: left;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dropdownValue:empty::before {\n  content: attr(data-placeholder);\n  color: var(--text-neutral-stronger);\n}\n\n.searchInputInline {\n  flex: 1;\n  border: none;\n  background: transparent;\n  outline: none;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: 24px;\n  color: var(--text-neutral-dark);\n  min-width: 0;\n  padding: 0;\n}\n\n.searchInputInline::placeholder {\n  color: var(--text-neutral-strong);\n}\n\n.pill {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-0-5);\n  padding: 0 var(--spacing-1);\n  background-color: var(--surface-primary-subtle);\n  border: 1px solid var(--surface-primary-medium);\n  border-radius: var(--radius-pill);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-100);\n  color: var(--text-primary-medium);\n  height: 24px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n.pillText {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.remainingCount {\n  white-space: nowrap;\n}\n\n.pillIconButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  margin-left: var(--spacing-0-5);\n  background: none;\n  border: none;\n  cursor: pointer;\n  outline: none;\n  flex-shrink: 0;\n  transition: opacity var(--transition-fast);\n}\n\n.pillIconButton:hover {\n  opacity: var(--opacity-0-8);\n}\n\n.pillIconButton:focus {\n  outline: 1px solid var(--surface-primary-medium);\n  outline-offset: 2px;\n  border-radius: var(--radius-xs);\n}\n\n.pillIcon {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n  filter: brightness(0) saturate(100%) invert(44%) sepia(92%) saturate(2686%) hue-rotate(6deg) brightness(76%)\n    contrast(104%);\n  transition: filter var(--transition-fast);\n}\n\n.pillIconButton:hover .pillIcon {\n  filter: brightness(0) saturate(100%) invert(12%) sepia(4%) saturate(230%) hue-rotate(330deg) brightness(76%)\n    contrast(95%);\n}\n\n.dropdownIconButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  outline: none;\n  flex-shrink: 0;\n  position: absolute;\n  right: var(--spacing-1-5);\n}\n\n.dropdownIconButton:focus {\n  outline: 1px solid var(--surface-primary-medium);\n  outline-offset: 2px;\n  border-radius: var(--radius-xs);\n}\n\n.dropdownIconButton:disabled {\n  cursor: not-allowed;\n  opacity: var(--opacity-0-5);\n}\n\n.dropdownIcon {\n  color: var(--surface-primary-medium);\n  width: var(--spacing-2);\n  height: var(--spacing-2);\n  transition: transform var(--transition-normal);\n  pointer-events: none;\n  flex-shrink: 0;\n}\n\n.dropdownIconOpen {\n  transform: rotate(180deg);\n}\n\n.dropdownOptions {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background-color: var(--surface-neutral-white);\n  border: 1px solid var(--surface-neutral-silver);\n  border-radius: var(--radius-s);\n  box-shadow: var(--shadow-sm);\n  z-index: 1000;\n  margin-top: 2px;\n  max-height: 250px;\n  overflow-y: auto;\n  animation: dropdownSlideDown var(--transition-normal);\n}\n\n.dropdownOption {\n  padding: 10px 12px;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: 20px;\n  color: var(--text-neutral-dark);\n  background-color: var(--surface-neutral-white);\n  cursor: pointer;\n  transition: background-color var(--transition-fast);\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  border: none;\n  width: 100%;\n  text-align: left;\n}\n\n.dropdownOption:nth-child(odd) {\n  background-color: var(--surface-neutral-pale);\n}\n\n.dropdownOption.selected {\n  color: var(--text-neutral-dark);\n}\n\n.dropdownOption.disabled {\n  cursor: not-allowed;\n  opacity: var(--opacity-0-5);\n  color: var(--text-neutral-medium);\n}\n\n.checkboxWrapper {\n  display: flex;\n  align-items: center;\n  pointer-events: none;\n}\n\n.checkboxWrapper > * {\n  pointer-events: auto;\n}\n\n.optionLabel {\n  flex: 1;\n  text-align: left;\n}\n\n@keyframes dropdownSlideDown {\n  from {\n    opacity: 0;\n    transform: translateY(calc(var(--spacing-1) * -1));\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.noResults {\n  padding: var(--spacing-2);\n  text-align: center;\n  color: var(--text-neutral-medium);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-style: italic;\n  background-color: var(--surface-neutral-pale);\n}\n\n@media (max-width: 768px) {\n  .label {\n    margin-bottom: var(--spacing-1);\n  }\n\n  .dropdownTrigger {\n    padding: var(--spacing-1) var(--spacing-1-5);\n    padding-right: var(--spacing-4);\n  }\n\n  .dropdownOption {\n    padding: var(--spacing-1) var(--spacing-1-5);\n  }\n\n  .pill {\n    font-size: var(--font-size-xs);\n    padding: var(--spacing-0-5);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `mKWplX`,
	"label": `JOmzBA`,
	"dropdownTrigger": `gsJJ1E`,
	"disabled": `gQRSZT`,
	"error": `rgJf1U`,
	"small": `iRdYj5`,
	"medium": `MCO9fP`,
	"large": `tar2mf`,
	"dropdownContent": `GGX7Xq`,
	"dropdownValue": `uNBOrV`,
	"searchInputInline": `eY4iBQ`,
	"pill": `JzNcgd`,
	"pillText": `PkggcX`,
	"remainingCount": `INUkmm`,
	"pillIconButton": `pj2d3R`,
	"pillIcon": `AflIZ4`,
	"dropdownIconButton": `K55Zi3`,
	"dropdownIcon": `NwcPXK`,
	"dropdownIconOpen": `KOA7gx`,
	"dropdownOptions": `DtzwLA`,
	"dropdownSlideDown": `IlqWIT`,
	"dropdownOption": `UNynuF`,
	"selected": `YORTC_`,
	"checkboxWrapper": `XiGi4k`,
	"optionLabel": `Rq4zwI`,
	"noResults": `yZwL_B`
};
module.exports = ___CSS_LOADER_EXPORT___;
